import React from 'react';
import PropTypes from 'prop-types';

const Lock = ({ color = '#8C949C' }) => (
    <svg
        width="18px"
        height="18px"
        viewBox="0 0 18 18"
        version="1.1"
        xmlns="http://www.w3.org/2000/svg"
    >
        <g
            id="Svg-Icons/18px-(All-icons)/UI/lock"
            stroke="none"
            strokeWidth="1"
            fill="none"
            fillRule="evenodd"
        >
            <polygon
                id="Bounds"
                fillOpacity="0.1"
                fill="#FF0000"
                opacity="0"
                points="0 0 10 0 10 10 0 10"
            />
            <path
                d="M15.1388776,6.75 L14.0555443,6.75 L14.0555443,5.24998828 C14.0555443,2.35511719 11.7876875,0 9,0 C6.2123125,0 3.94445573,2.35511719 3.94445573,5.24998828 L3.94445573,6.75 L2.8611224,6.75 C2.66151823,6.75 2.5,6.91773047 2.5,7.12501172 L2.5,16.5000234 C2.5,17.3272852 3.14779948,18 3.94445573,18 L14.0555781,18 C14.8522005,18 15.5,17.3272852 15.5,16.4999883 L15.5,7.12501172 C15.5,6.91773047 15.3384818,6.75 15.1388776,6.75 Z M10.0812344,14.5836211 C10.0925078,14.6894414 10.059737,14.7956484 9.99131771,14.8751367 C9.92289844,14.9545898 9.82485677,15.0000117 9.72224479,15.0000117 L8.27778906,15.0000117 C8.17517708,15.0000117 8.07713542,14.9545898 8.00871615,14.8751367 C7.94029688,14.7956836 7.90749219,14.6894766 7.91879948,14.5836211 L8.14660417,12.4563164 C7.77667969,12.1768945 7.55557813,11.734875 7.55557813,11.25 C7.55557813,10.4227383 8.2033776,9.74998828 9.00003385,9.74998828 C9.7966901,9.74998828 10.4444896,10.4227031 10.4444896,11.25 C10.4444896,11.734875 10.223388,12.1768945 9.85346354,12.4563164 L10.0812344,14.5836211 Z M11.8888776,6.75 L6.1111224,6.75 L6.1111224,5.24998828 C6.1111224,3.59581641 7.40709375,2.25 9,2.25 C10.5929063,2.25 11.8888776,3.59581641 11.8888776,5.24998828 L11.8888776,6.75 Z"
                id="Shape"
                fill={color}
            />
        </g>
    </svg>
);

Lock.propTypes = {
    color: PropTypes.string,
};

export default Lock;
